// extracted by mini-css-extract-plugin
export default {"menuBlock":"WF-z","title":"XF-z","nav":"YF-z","flexCell":"ZF-z","facetLink":"_F-z"};